import { useState, useEffect } from 'react';

import { useIntersectionObserver } from '../hooks';
import { Box } from '../Box';
import { CircularProgress } from '../CircularProgress';

import { FilePreviewWrapper } from './FilePreviewWrapper';
import { FilePreviewProps } from './FilePreview.types';

/**
 * Компонент для отложенной загрузки и отображения превью файла с использованием Intersection Observer.
 *
 * @public
 * @param props - Свойства компонента {@link FilePreviewProps}.
 * @returns  JSX-элемент, представляющий превью файла.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link FilePreviewProps}
 */
export const FilePreview = (props: FilePreviewProps) => {
  const [isIntersected, setIsIntersected] = useState(false);

  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: '100px',
  });

  useEffect(() => {
    if (entry?.isIntersecting) {
      setIsIntersected(true);
    }
  }, [entry?.isIntersecting]);

  return (
    <>
      <Box ref={ref} component="span" position="absolute" />
      {isIntersected ? (
        <FilePreviewWrapper {...props} />
      ) : (
        !props.hideLoader && (
          <Box display="flex" justifyContent="center" p="32">
            <CircularProgress size={50} />
          </Box>
        )
      )}
    </>
  );
};
